import { useParams, useLocation } from 'react-router-dom';
import TrackerEditContainer from './TrackerEditContainer';
import { Ingredient } from '../types';

const TrackerEditPage = () => {
  const { dietMealId } = useParams();
  const {
    ingredients: initialIngredients,
    timestamp,
    mealName,
    requestId,
  } = useLocation().state as {
    ingredients: Ingredient[];
    timestamp: number;
    mealName: string;
    requestId: string;
  };
  return (
    <TrackerEditContainer
      key={dietMealId}
      initialIngredients={initialIngredients}
      timestamp={timestamp}
      mealName={mealName}
      requestId={requestId}
      mode="backward-navigation" // for coockbook, mealplan and tracker details meals
    />
  );
};

export default TrackerEditPage;
